import {createFileRoute} from '@tanstack/react-router'
import ReferralLinkPage from "../pages/ReferralLinkPage.tsx";

export const Route = createFileRoute('/r/$referrals_code')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ReferralLinkPage />
}
